module.exports = __webpack_public_path__ + "static/media/polygon-green.276afc71.svg";